var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row mt-3"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"page-title-box d-flex align-items-center justify-content-between"},[_c('h5',{staticClass:"mb-0",staticStyle:{"font-weight":"bolder"}},[_vm._v(_vm._s(_vm.title))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }